module.exports = __webpack_public_path__ + "static/media/B4.11dc5c8b.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B4.png
// module id = 883
// module chunks = 0